import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { buildCommittedStateExpiresAt } from 'tripPlanner/assistant/surfaceSnapshots/expiry'
import type { TripPlannerCommittedStateEntry } from 'tripPlanner/assistant/surfaceSnapshots/committedStateEntry'
import type { ListingDrawerHotelDateSelection } from '../ListingDrawerSearchDates'
import { formatHotelSearchDisplayText } from './formatHotelSearchDisplayText'

// Keyed per stop (matching `resolveSearchDefaults`'s own per-stop lookup and the retiring
// `appendRecentSearchHiddenContext`'s own `trip_stop_id` disambiguation) -- a flat key would
// regress real, already-shipped search-default behavior. No stopless fallback: this drawer is
// only ever opened with a stop in context, unlike flight search's own genuinely stopless case.
export function buildLastHotelSearchCommittedStateEntry(
  stopId: number,
  searchQuery: string,
  dateSelection: ListingDrawerHotelDateSelection,
  occupancies: Array<App.Occupants>,
): TripPlannerCommittedStateEntry {
  return {
    key: `search:hotel:stop:${stopId}`,
    kind: 'last_hotel_search',
    label: 'Last hotel search',
    displayText: boundActivityDisplayText(formatHotelSearchDisplayText(searchQuery, dateSelection, occupancies)),
    sourcePath: 'trip_planner.search.hotel',
    dataClassification: 'personalised_surface',
    expiresAt: buildCommittedStateExpiresAt(),
  }
}
